import { render } from "./ApprovalManagement.vue?vue&type=template&id=efffd3b6&scoped=true"
import script from "./ApprovalManagement.vue?vue&type=script&lang=js"
export * from "./ApprovalManagement.vue?vue&type=script&lang=js"

import "./ApprovalManagement.vue?vue&type=style&index=0&id=efffd3b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efffd3b6"]])

export default __exports__